export default __webpack_public_path__ + "static/media/화이트홀스.d3411107.svg";